module.exports = __webpack_public_path__ + "static/media/ourTeam.02df5011.jpg";